import { orgId, domainId, domain } from "@common/schema/organization/fields";

export const email = {
  label: "Email",
  type: "string",
};

export { orgId, domainId, domain }